import { createFileRoute } from "@tanstack/react-router";
import { SubscriptionPayPage } from "@/components/subscription/SubscriptionPayPage";
import { isSubscriptionPayToken, parseOutcome } from "@/lib/payment-return-url";

// Monri return URL of a subscription payment. The outcome lives in the path;
// the query string belongs to Monri and is ignored.
export const Route = createFileRoute("/subscription/pay/$token/$outcome")({
  component: PayReturnRoute,
});

function PayReturnRoute() {
  const { token, outcome } = Route.useParams();
  const returnStatus = isSubscriptionPayToken(token) ? parseOutcome(outcome) : "unknown";
  return <SubscriptionPayPage token={token} returnStatus={returnStatus} />;
}
